<template>
    <div class="task" :style="mainContentViewHeight">
        <div class="top">
            <p>
                <span class="title">待办箱</span>
            </p>
            <div class="search">
                <el-input placeholder="请输入项目名称或项目编号" v-model="dataForm.searchKey" clearable></el-input>
                <el-button class="search-btn" type="primary" @click="searchHandle">搜索</el-button>
                <el-button type="text" @click="drawer=true; apiUserTaskQueryRegion();">更多搜索</el-button>
                <span class="search-line"></span>
                <i class="el-icon-refresh" @click="refreshHandler"></i>
                <el-drawer
                    title="更多筛选"
                    :visible.sync="drawer"
                    custom-class="drawer-more"
                    size="576px"
                    direction="rtl"
                    :append-to-body="true"
                >
                    <template #default>
                        <div class="drawerform">
                            <div class="drawerform-row">
                                <div class="drawerform-row--title">地区：</div>
                                <div class="drawerform-row--content drawerform-row--list">
                                    <span
                                        v-for="item in areaList"
                                        :key="item.value"
                                        :class="dataForm.regionCode === item.regionCode ?'active':null"
                                        @click="areaHandler(item)"
                                    >{{item.regionName}}</span>
                                </div>
                            </div>
                            <div class="drawerform-row">
                                <div class="drawerform-row--title">待办状态：</div>
                                <div class="drawerform-row--content drawerform-row--list">
                                    <span
                                        v-for="item in historyidList"
                                        :key="item.value"
                                        :class="dataForm.historyid === item.value ?'active':null"
                                        @click="historyidHandler(item)"
                                    >{{item.text}}</span>
                                </div>
                            </div>
                            <div class="drawerform-row">
                                <div class="drawerform-row--title">提交时间：</div>
                                <div class="drawerform-row--content">
                                    <el-date-picker
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        v-model="processDate"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :default-time="['00:00:01', '23:59:59']"
                                    ></el-date-picker>
                                </div>
                            </div>
                            <div class="drawerform-row">
                                <div class="drawerform-row--title">处理时间：</div>
                                <div class="drawerform-row--content">
                                    <el-date-picker
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        v-model="finishTime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :default-time="['00:00:01', '23:59:59']"
                                    ></el-date-picker>
                                </div>
                            </div>
                            <p class="drawerform-btns">
                                <el-button type="primary" @click="searchHandle">查询</el-button>
                                <el-button @click="clearHandler">清空</el-button>
                            </p>
                        </div>
                    </template>
                </el-drawer>
            </div>
            <div class="task-tabs">
                <div
                    class="tab-item"
                    v-for="item in navList"
                    :key="item.value"
                    :class="dataForm.taskType === item.value?'active':null"
                    @click="navHandler(item)"
                >
                    {{item.text}}<i class="badge-defult" :class="item.num>0?'badge-red':null">{{item.num>=99?'99+':item.num}}</i>
                </div>
            </div>
        </div>
        <div class="table-content">
            <el-table
                :data="tableData"
                stripe
                border
                size="mini"
                style="width: 100%;"
                v-loading="loading"
                @sort-change="sortChange"
                @filter-change="filterChange"
                ref="table"
                :height="tableMaxHeight"
            >
                <el-table-column
                    label="序号"
                    type="index"
                    width="80px"
                    align="center"
                    fixed="left"
                    :index="indexMethod"
                ></el-table-column>
                <el-table-column
                    v-for="item in columns"
                    :key="item.id"
                    :label="item.label"
                    :type="item.type"
                    :width="item.width"
                    :align="item.align"
                    :min-width="item.minWidth"
                    :show-overflow-tooltip="item.showOverflowTooltip"
                    :prop="item.prop"
                    :column-key="item.columnKey"
                    :sortable="item.sortable"
                    :filters="item.filters"
                    :fixed="item.fixed"
                >
                    <template slot-scope="scope">
                        <!-- 按钮 -->
                        <el-button
                            v-if="item.btns"
                            type="text"
                            @click="viewHandle(scope.row)"
                        >查看
                        </el-button>
                        <!-- 状态类型 -->
                        <span
                            v-else-if="item.domType==='status'"
                            class="status"
                            :class="scope.row.historyid===0?'status-done':null"
                            >{{scope.row[item.prop]|historyidFilter}}
                        </span>
                        <!-- tag类型 -->
                        <span
                            v-else-if="item.domType==='tag'"
                            class="tag"
                            :class="setProjectClass(scope.row[item.prop],item.prop)"
                        >{{scope.row[item.prop]|projectTypeMapperName(item.prop)}}
                        </span>
                        <!-- 普通文字 -->
                        <span v-else :class="setClass(item.prop,scope.row)">{{scope.row[item.prop] | formatterFilter(item.prop)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="limit">
                <!-- <el-pagination
                    background
                    class="limit-pagination"
                    :total="total"
                    :page-sizes="[20, 30, 50, 100]"
                    :page-size="pageSize"
                    :current-page="pageIndex"
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    layout="total, sizes, prev, pager, next, jumper"
                ></el-pagination> -->
                <pagination
                    class="limit limit-pagination"
                    :page-sizes="[20, 30, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
let columns = [
    {id:20,label:'状态',width:'100px',align:'center',prop:'historyid',domType:'status',fixed:'left'},
    {id:30,label:'待办类型',minWidth:'110px',align:'center',prop:'taskType',domType:'tag',fixed:'left',columnKey:'taskType'},
    {id:40,label:'项目/标段名称',minWidth:'240px',showOverflowTooltip:true,prop:'projectName'},
    {id:50,label:'业务节点',minWidth:'180px',align:'center',prop:'datasetCode',columnKey:'datasetCode',filters:[],domType:'tag'},
    {id:60,label:'处理/等待时长',minWidth:'160px',prop:'dateDiff',sortable: true},
    {id:70,label:'提交时间',minWidth:'160px',prop:'createDate',sortable: true},
    {id:80,label:'处理时间',minWidth:'160px',prop:'finishTime',sortable: true},
    // {id:90,label:'处理人',minWidth:'150px'},
    {id:100,label:'项目/标段编号',minWidth:'240px',showOverflowTooltip:true,prop:'projectCode'},
    {id:110,label:'操作',width: '100px',align:'center',btns: true,fixed:'right'},
]
import mixin from '@/mixins/dealt.js';
import {apiUserTaskListBox,apiUserTaskQueryRegion} from '@/server/new.js';
import Pagination from '@/components/Pagination.vue';
export default {
    components:{
        Pagination
    },
    mixins: [mixin],
    props: ['mainContentViewHeight'],
    data() {
        return {
            drawer: false,
            tableMaxHeight: document.documentElement.clientHeight - 108 - 20 - 55 - 60 - 40 - 44 - 20 - 2, //top筛选 边距 navs 头 内边距 搜索 默认
            navList: [
                {text: '全部',value: '',num: 0},
                {text: '工程建设',value: 'GC',num: 0},
                {text: '政府采购',value: 'CG',num: 0},
                {text: '协同办公',value: 'XT',num: 0},
                {text: '其他',value: 'QT',num: 0},
                {text: '产权交易',value: 'CQ',num: 0},
            ],
            areaList: [],
            historyidList: [
                {text: '全部',value: null},
                {text: '待处理',value: -1},
                {text: '已完成',value: 0},
            ],
            columns: columns,
            dataForm: {
                searchKey: '', //搜索内容
                taskType: '', //类型
                datasetCodeList: [], //业务节点筛选数组
                regionCode: null, //地区筛选
                historyid: null, //待办状态
            },
            processDate: '', //提交时间
            finishTime: '', //处理时间
        }
    },
    mounted() {
        this.fetchData();
        this.navList.forEach(async (item) => {
            await this.apiUserTaskTotal(item.value,-1);
        })
    },
    methods: {
        apiUserTaskQueryRegion() {
            apiUserTaskQueryRegion(window.SITE_CONFIG.regionCode).then(({data}) => {
                let temp = data.data;
                temp.shift();
                temp.unshift({
                    regionCode: null,
                    regionName: '全部'
                })
                this.areaList = temp;
            })
        },
        fetchData() { //获取表格数据
            let processDateStart = this.processDate?this.processDate[0]:null;
            let processDateEnd = this.processDate?this.processDate[1]:null;
            let finishTimeStart = this.finishTime?this.finishTime[0]:null;
            let finishTimeEnd = this.finishTime?this.finishTime[1]:null;
            this.loading = true;
            apiUserTaskListBox({
                page: this.pageIndex,
                rows: this.pageSize,
                searchKey: this.dataForm.searchKey,
                filter: {
                    taskType: this.dataForm.taskType,
                    datasetCodeList: this.dataForm.datasetCodeList,
                    historyid: this.dataForm.historyid,
                    processDateStart,
                    processDateEnd,
                    finishTimeStart,
                    finishTimeEnd,
                    regionCode: this.dataForm.regionCode,
                },
                orderBy: this.sortParams.prop && this.sortParams.order ? this.sortParams.prop+(this.sortParams.order == "ascending" ? " asc" : " desc"):''
            }).then(({data}) => {
                this.tableData = data.rows || [];
                this.total = data.total || 0;
            }).finally(() => {this.loading = false;})
        },
        viewHandle(row) {
            // window.location.href = row.url;
            this.$router.push({
                path: row.url
            })
        },
        searchHandle() { //搜索按钮
            this.pageIndex = 1;
            this.navList.forEach(async (item) => {
                this.apiUserTaskTotal(item.value);
            })
            this.fetchData();
        },
        clearHandler() { //清除按钮
            let data = JSON.parse(JSON.stringify(this.$data))
            Object.assign(this.$data, this.$options.data.call(this))
            this.dataForm.searchKey = data.dataForm.searchKey;
            this.fetchData();
            this.navList.forEach(async (item) => {
                await this.apiUserTaskTotal(item.value);
            })
        },
        historyidHandler(row) { // 更多筛选 待办状态点击
            this.dataForm.historyid = row.value;
        },
        areaHandler(row) { // 更多筛选 地区点击
            this.dataForm.regionCode = row.regionCode;
        },
        refreshHandler() { //刷新
            this.pageIndex = 1;
            this.fetchData();
        },
        setClass(key,row) {
            if(key === 'dateDiff') {
                if(row.historyid === -1) {
                    return 'text-red'
                }else {
                    return null;
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .drawer-more {
    :focus {
        outline: 0;
    }
    .el-drawer__header {
        margin-bottom: 0;
    }
    .drawerform {
        padding: 0 20px 20px;
        .drawerform-row {
            display: flex;
            align-items: flex-start;
            position: relative;
            margin-top: 20px;
            padding-bottom: 20px;
            &:after {
                content: '';
                width: 100%;
                height: 1px;
                background: linear-gradient(
                    to left,
                    transparent 0%,
                    transparent 50%,
                    #ccc 50%,
                    #ccc 100%
                );
                background-size: 10px 1px;
                background-repeat: repeat-x;
                position: absolute;
                left: 0;
                bottom: 0;
            }
            &:last-of-type:after {
                display: none;
            }
            .drawerform-row--title {
                height: 36px;
                line-height: 36px;
                min-width: 80px;
                text-align: right;
            }
            .drawerform-row--content {
                margin-left: 10px;
                display: flex;
                flex-wrap: wrap;
            }
            .drawerform-row--list {
                margin-left: 5px;
                span {
                    display: inline-block;
                    width: 82px;
                    padding: 10px 20px;
                    text-align: center;
                    cursor: pointer;
                    border-radius: 4px;
                    margin: 0 5px 10px 5px;
                    // &+span {
                    //     margin-left: 10px;
                    // }
                    &:hover,&.active {
                        background-color: @--color-primary;
                        color: #fff;
                    }
                }
            }
        }
        .drawerform-btns {
            margin-top: 50px;
        }
    }
}
.task {
    position: relative;
    .top {
        background: #fff;
        // padding: 30px 40px 10px 24px;
        padding: 24px 40px 0 24px;
        height: 108px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        width: calc(100% + 48px);
        position: relative;
        left: -24px;
        >p {
            .title {
                font-size: 18px;
                font-weight: 700;
            }
        }
        .search {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 24px;
            left: 50%;
            transform: translateX(-50%);
            /deep/ .el-input {
                width: 350px;
                .el-input__inner {
                    height: 40px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right: 0;
                }
            }
            .search-btn {
                height: 40px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 14px;
                padding: 9px 20px;
            }
            .search-line {
                width: 1px;
                height: 16px;
                background-color: rgba(0,0,0,.25);
                margin: 0 10px;
            }
            i {
                cursor: pointer;
                &:hover {
                    color: @--color-primary;
                }
            }
        }
        .task-tabs {
            margin-top: 24px;
            display: flex;
            .tab-item {
                cursor: pointer;
                padding: 12px 10px;
                position: relative;
                margin-right: 10px;
                i {
                    margin-left: 8px;
                }
                &:after {
                    content: '';
                    width: 0%;
                    height: 2px;
                    background: @--color-primary;
                    position: absolute;
                    bottom: 0px;
                    left: 0;
                    transition: all 0.3s;
                }
                &:hover{
                    color: @--color-primary;
                }
                &:hover:after{
                    width: 100%;
                }
                &.active {
                    color: @--color-primary;
                    &:after{
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: @--color-primary;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                    }
                }
            }
        }
    }
    .table-content {
        background-color: #fff;
        margin-top:24px;
        padding: 16px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .status {
            padding-left: 15px;
			position: relative;
			&:before{
				content: '';
				width: 6px;
				height: 6px;
				border-radius: 50%;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translate(0,-50%);
				background: #FF0000;
			}
            &.status-done {
                &:before {
                    background: #52C41A;
                }
            }
        }
        .tag {
            display: inline-block;
			border-radius: 3px;
			padding: 8px 10px;
			font-size: 12px;
			line-height: 12px;
            // 各项目类型颜色
            &.project_GC{
                background: #F0F9EA;
                border: 1px solid #C2E7B0;
                color: #67C239;
            }
            &.project_CG{
                background: #ECF5FF;
                border: 1px solid #A3D0FD;
                color: @--color-primary;
            }
            &.project_CQ{
                background: #FFFBE6;
                border: 1px solid #FFE58F;
                color: #FF9901;
            }
            &.project_GT{
                background: #FFF0F6;
                border: 1px solid #FFADD2;
                color: #F5307F;
            }
            &.project_QT{
                background: #E6FFFB;
                border: 1px solid #87E8DE;
                color: #13C2C2;
            }
        }
        .text-red {
            color: #F5307F;
        }
    }
}
</style>
